import { render } from "./QuestionAndAnswer.vue?vue&type=template&id=4978c756"
import script from "./QuestionAndAnswer.vue?vue&type=script&lang=js"
export * from "./QuestionAndAnswer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/QuestionAndAnswer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4978c756"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4978c756', __exports__)) {
    api.reload('4978c756', __exports__)
  }
  
  module.hot.accept("./QuestionAndAnswer.vue?vue&type=template&id=4978c756", () => {
    api.rerender('4978c756', render)
  })

}


export default __exports__